export interface LocalizedFields {
  name: string;
  pt?: string;
  en?: string;
  es?: string;
}

export const getLocalizedName = (item: LocalizedFields, locale: string): string => {
  if (locale.startsWith("pt") && item.pt) return item.pt;
  if (locale.startsWith("en") && item.en) return item.en;
  if (locale.startsWith("es") && item.es) return item.es;
  return item.name;
};
